import React from 'react';
import {Col, Container, Row, Nav, Tab, Accordion} from "react-bootstrap";

function Consulting(props) {
    return (
        <section className="tekgrip_section tekrevol_dark_bg p-100">
            <Container className="h-100">
                <Row className="h-100">
                    <Col xs={12} md={12} lg={10} xl={10} xxl={10} className="my-auto">
                        <div className="example" data-text="AZURE Services">
                            <h2>What You Get From MS Azure Consulting</h2>
                        </div>

                    </Col>
                    <Col xs={12} md={12} lg={12} xl={12} xxl={12} className="tekgrip_tabs deskstop_version">
                        <Tab.Container id="" defaultActiveKey="0">
                            <Row>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Nav variant="pills" className="flex-column">
                                        <Nav.Item>
                                            <Nav.Link eventKey="0">Superfast cloud infrastructure</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="1">Scalability options</Nav.Link>
                                        </Nav.Item>
                                        <Nav.Item>
                                            <Nav.Link eventKey="2">IAAS & PAAS capabilities</Nav.Link>
                                        </Nav.Item>
                                    </Nav>
                                </Col>
                                <Col xs={12} md={6} lg={6} xl={6}>
                                    <Tab.Content>

                                        <Tab.Pane eventKey="0">
                                            <p>TekRevol's Azure consulting services offer businesses with a rapid fast cloud infrastructure, allowing them to provide products and services to their stakeholders quicker than ever before. With Microsoft Azure, TekRevol guarantees that businesses can experience swift and consistent access to their applications and data.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="1">
                                            <p>Our Azure consulting services offer businesses with the flexibility to increase or decrease their infrastructure, giving them a cost-effective resolution that can effortlessly adjust to varying business requirements. With TekRevol's proficiency in Azure, businesses can warrant that their applications and services are always accessible and can handle the enhanced demand during peak times.</p>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="2">
                                            <p>TekRevol's Azure consulting services offer businesses with both Infrastructure-as-a-Service (IaaS) and Platform-as-a-Service (PaaS) capabilities, allowing them to develop, deploy and manage applications on the cloud. With TekRevol's proficiency in Azure, businesses can influence the authority of the cloud to generate advanced solutions and stay in advance of the competition.</p>
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                            </Row>
                        </Tab.Container>
                    </Col>
                    <Col xs={12} md={12} lg={8} xl={8} xxl={8} className="mobile_version">
                        <div className="tekrevol_mobile_accordion">
                            <Accordion
                                defaultActiveKey="0">
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header>Superfast cloud infrastructure</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's Azure consulting services offer businesses with a rapid fast cloud infrastructure, allowing them to provide products and services to their stakeholders quicker than ever before. With Microsoft Azure, TekRevol guarantees that businesses can experience swift and consistent access to their applications and data.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header>Scalability options</Accordion.Header>
                                    <Accordion.Body>
                                        <p>Our Azure consulting services offer businesses with the flexibility to increase or decrease their infrastructure, giving them a cost-effective resolution that can effortlessly adjust to varying business requirements. With TekRevol's proficiency in Azure, businesses can warrant that their applications and services are always accessible and can handle the enhanced demand during peak times.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="2">
                                    <Accordion.Header>IAAS & PAAS capabilities</Accordion.Header>
                                    <Accordion.Body>
                                        <p>TekRevol's Azure consulting services offer businesses with both Infrastructure-as-a-Service (IaaS) and Platform-as-a-Service (PaaS) capabilities, allowing them to develop, deploy and manage applications on the cloud. With TekRevol's proficiency in Azure, businesses can influence the authority of the cloud to generate advanced solutions and stay in advance of the competition.</p>
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </div>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default Consulting;